import React, { useCallback } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Blocks from '../blocks/Blocks';
import Title from '../partials/Title';

import * as AppPropTypes from '../../lib/PropTypes';
import FullButton from '../buttons/Full';

import styles from '../../../styles/pages/normal.scss';
import { usePopup } from '../../contexts/PopupContext';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const NormalPage = ({ page }) => {
    const { popup, setPopupWithoutCookie } = usePopup();
    const { handle = null } = page || {};
    const onClickCookies = useCallback(() => {
        setPopupWithoutCookie(popup === 'cookies' ? null : 'cookies');
    }, [popup, setPopupWithoutCookie]);

    return (
        <div className={styles.container}>
            <Title
                className={styles.title}
                seed={`title-${page.id}`}
                text={page.title}
                format="normal"
                borderPosition="bottom"
            />
            <div className={styles.blocksContainer}>
                {handle === 'privacy' ? (
                    <FullButton className={styles.button} small onClick={onClickCookies}>
                        <FormattedMessage
                            id="content.cookies.button"
                            defaultMessage="Modifier mes paramètres"
                        />
                    </FullButton>
                ) : null}
                <Blocks
                    className={styles.blocks}
                    blockClassName={styles.block}
                    blocks={page.blocks}
                />
            </div>
        </div>
    );
};

NormalPage.propTypes = propTypes;

export default NormalPage;
